<template>
  <div class="text-left">
    <appointmentModal
      :item="appointmentDetail"
      @detailEdited="setAppointmentList()"></appointmentModal>
    <div class="ml-auto mb-3">
      <div class="row">
        <div class="col-12 col-md-auto">
          <b-button class="form-control mt-1 mt-md-0" variant="primary" :disabled="editBlock" v-b-toggle.edit-hours>
            {{ $t("header.edit") }} {{ $t("subMenu.my_salon_appointment") }}
            {{ $t("header.booking_hour") }}
          </b-button>
        </div>
        <div class="col-12 col-md-auto">
          <exportCSV
            class="form-control mt-1 mt-md-0 link btn buttons-csv buttons-html5 btn-primary mr-2 "
            :data="exportData"
            :fields="exportFields"
            :header="exportHeaders"
            type="csv"
            :escapeCsv="false"
            :name="exportFileName">
            <span>CSV</span>
          </exportCSV>
        </div>
        <div class="col"></div>
        <!-- <div class="col-12 mt-1 mt-md-0 col-md-auto">
          <button class="form-control btn ml-1 buttons-csv buttons-html5 btn-outline-primary" type="button" @click="addAppointment">
            + Add Appointment
          </button>
        </div> -->
      </div>
      <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
    </div>
    <div class="ml-auto mb-3 d-flex justify-content-between">
      <b-collapse
        id="edit-hours"
        class="mt-2 w-100 p-3"
        style="border-radius: 25px; background-color: #ececec">
        <div class="d-flex justify-content-between mb-3 col-md-12">
          <multiselect
            v-model="hoursOutlet"
            label="text"
            track-by="id"
            :options="hourOutlet"
            :searchable="false"
            :show-labels="false"
            :allow-empty="false"
            openDirection="below"
            @select="getApptHours"
            class="col-md-4">
            <template slot="option" slot-scope="{ option }">{{
              option.text
            }}</template>
            <span slot="noResult">{{ $t("table.no_records") }}</span>
          </multiselect>
          <select
            name="predefinedHours"
            class="form-control col-md-4"
            v-model="predefinedHours">
            <option value="" disabled>--Auto Set Hours--</option>
            <option value="1">9 AM to 5 PM</option>
            <option value="2">10 AM to 6 PM</option>
            <option value="3">All</option>
          </select>
        </div>
        <template v-if="spinnerHour">
          <div class="col-lg-12 d-flex justify-content-center">
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </template>
        <template v-if="hoursOutlet.id != '' && !spinnerHour">
          <div class="d-flex justify-content-center flex-wrap px-6">
            <div class="hourButtons">
              <b-button
                pill
                variant="outline-primary"
                :class="apptHours[0].appt ? 'active' : ''"
                class="m-2 my-1 w-100"
                @click="onApptHourToggle(0)">12:00AM</b-button>
            </div>
            <div class="hourButtons" v-for="index in 11" :key="index">
              <b-button
                pill
                variant="outline-primary"
                :class="apptHours[index].appt ? 'active' : ''"
                class="m-2 my-1 w-100"
                @click="apptHours[index].appt = !apptHours[index].appt">{{ index }}:00AM</b-button>
            </div>
          </div>
          <div class="d-flex justify-content-center flex-wrap px-6">
            <div class="hourButtons">
              <b-button
                pill
                variant="outline-primary"
                :class="apptHours[12].appt ? 'active' : ''"
                class="m-2 my-1 w-100"
                @click="apptHours[12].appt = !apptHours[12].appt">12:00PM</b-button>
            </div>
            <div class="hourButtons" v-for="index in 11" :key="index">
              <b-button
                pill
                variant="outline-primary"
                :class="apptHours[index + 12].appt ? 'active' : ''"
                class="w-100 my-1 m-2"
                @click="
                  apptHours[index + 12].appt = !apptHours[index + 12].appt
                  ">{{ index }}:00PM</b-button>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button variant="primary" @click="updateApptHours(apptHoursClone)">Apply</b-button>
          </div>
        </template>
      </b-collapse>
    </div>
    <div class="row text-left mb-2">
      <div class="col-12 col-md-6 mb-2">
        <div class="dataTables_filter">
          <label class="d-flex mb-0">
            <input
              type="search"
              class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
              :placeholder="$t('label.search') + $t('label.customer_name') + '/Mobile Number'"
              v-model="searchCustomer"
              @keypress.enter="filterBySearch">
            <button
              class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
              @click="filterBySearch()">
              <i class="fas fa-search"></i>
            </button>
          </label>
        </div>
      </div>
      <div class="col-12 col-md-6 mb-2">
        <date-range-picker
          class="w-100"
          ref="picker"
          v-model="dateRangeList"
          :opens="'right'"
          :autoApply="true"
          :ranges="dateRange"
          :showDropdowns="true"
          :always-show-calendars="true"
          :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
          :singleDatePicker="singleDatePicker"
          @showCustomRange="showCustomRangeCalendars = true"
          @update="filterByDate">
        </date-range-picker>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-store"></i>
              </label>
              <multiselect
                v-model="selectedOutlet"
                label="text"
                track-by="id"
                :options="outlet"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="filterByOutlet">
                <template slot="option" slot-scope="{ option }">{{
                  option.text
                }}</template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-user"></i>
              </label>
              <multiselect
                v-model="selectedStaff"
                :options="staffs"
                track-by="staffID"
                label="name"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="filterByStaff">
                <template slot="option" slot-scope="{ option }">
                  {{ option.name }}
                  <!-- <b-badge
                    pill
                    variant="danger"
                    class="ml-2"
                    v-if="option.total != 'all'">{{ option.total }}
                  </b-badge> -->
                </template>
                <span slot="noResult">{{ $t("table.no_records") }}</span>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md mb-2 d-flex align-items-end">
        <b-form-group :label="''" v-slot="{ ariaDescribedby }">
          <b-form-radio-group
            class="mb-2"
            id="rad_status"
            v-model="selectedStatus"
            :options="radStatus"
            :aria-describedby="ariaDescribedby"
            name="rad_status"
            @change="setAppointmentList()"></b-form-radio-group>
        </b-form-group>
      </div>
      <a class="col-12 col-xl-auto link text-primary" @click="clearFilter()">
      {{
        $t("button_link.clear_filter")
      }}
      </a>
    </div>
    <div class="row justify-content-between mt-2">
      <div class="d-flex py-2 pl-3">
        <b-button-group size="sm">
          <b-button
            variant="outline-primary"
            :class="apptSource == '' ? 'active' : ''"
            @click="apptSource = ''">All</b-button>
          <b-button
            variant="outline-primary"
            :class="apptSource == 'OL' ? 'active' : ''"
            @click="apptSource = 'OL'">Online</b-button>
          <b-button
            variant="outline-primary"
            :class="apptSource == 'EM' ? 'active' : ''"
            @click="apptSource = 'EM'">Emerchant</b-button>
        </b-button-group>
      </div>
      <div class="d-flex">
        <!-- <div class="col-auto pt-2">
          <span>{{
            $t("table.pagination", {
              startPage: startPage,
              endPage: endPage,
              totalEntries: totalEntries,
            })
          }}</span>
        </div>
        <div class="col-auto">
          <b-pagination
            class="ml-3"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalEntries"
            @input="handlePagination"></b-pagination>
        </div> -->
      </div>
    </div>
    <div v-show="tab === 'calendar'">
      <CalendarView
        ref="calendar"
        :selectedOutlet="selectedOutlet"
        :selectedStaff="selectedStaff"
        :apptHours="apptHours"
        @onCalendarDateChange="onCalendarDateChange"
        @onCalendarDateClick="onCalendarDateClick"
        @onCalendarEventClick="onCalendarEventClick">
      </CalendarView>
    </div>
    <div v-show="tab === 'scheduler'">
      <SchedulerView :items="apptLists" :staffs="staffs"></SchedulerView>
    </div>
    <div v-show="tab === 'list'">
      <div class="dataTables_wrapper dt-bootstrap4">
        <div class="row justify-content-end mt-2">
            <div class="col-auto pt-2">
                <span>
                    {{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, }) }}
                </span>
            </div>
            <div class="col-auto">
                <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
                    @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
            </div>
        </div>

        <div class="row" v-if="!isSpinnerShow && totalEntries != 0">
          <div class="col-sm-12 overflow-auto">
            <b-table
              striped
              hover
              bordered
              class="apptTable"
              :fields="fields"
              :items="apptLists">
              <template #cell(index)="data">
                {{ data.index + startPage }}
              </template>
              <template #cell(datetime)="data">
                <div class="font-weight-bold">{{ getDate(data.item.arrivalDate) }}</div>
                <div class="align-middle">
                  <span class="badge badge-pill badge-warning">
                    <i class="fas fa-clock"></i>
                  </span>
                  {{ getTime(data.item.arrivalDate) }} - {{ getTime(data.item.arrivalDate, data.item.duration) }}
                </div>
              </template>
              <template #cell(customer)="data">
                <div class="row">
                  <div class="col-auto">
                    <div class="font-weight-bold">{{ data.item.memberName }}</div>
                    <div class="align-middle">
                      <span class="badge badge-pill badge-success">
                        <i class="fas fa-phone"></i>
                      </span>
                      {{ data.item.memberMobile }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(service)="data">
                <div class="font-weight-bold">{{ data.item.skuName }}</div>
                <div class="align-middle">
                  by {{ data.item.staffName }}
                </div>
              </template>
              <template #cell(colorAndRemark)="data">
                <span v-if="data.item.colorHex && data.item.color" class="badge badge-pill"
                  :style="{ 'background-color': data.item.colorHex, 'color': 'white' }">{{ data.item.color }}</span>
                <div class="align-middle">
                  {{ data.item.remark }}
                </div>
              </template>
              <template #cell(status)="data">
                <div v-if="data.item.completedDate">
                  <div class="align-middle">
                    <span class="badge badge-pill badge-success" style="width: 25px">
                      <i class="fas fa-check"></i>
                    </span>
                    Completed
                  </div>
                </div>
                <div v-else-if="data.item.noshowDate">
                  <div class="align-middle">
                    <span class="badge badge-pill badge-warning" style="width: 25px">
                      <i class="fas fa-eye-slash"></i>
                    </span>
                    No Show
                  </div>
                </div>
                <div v-else>
                  <div class="align-middle">
                    <span class="badge badge-pill badge-primary" style="width: 25px">
                      <i class="fas fa-bookmark"></i>
                    </span>
                    Approved
                  </div>
                </div>
                <div v-if="data.item.blocked === 1">
                  <div class="align-middle">
                    <span class="badge badge-pill" style="width: 25px">
                      <i class="fas fa-shield"></i>
                    </span>
                    Blocked
                  </div>
                </div>
              </template>
              <template #cell(source)="data">
                <span
                  v-if="data.item.source == 'OL'">{{ $t("label.online") }}</span>
                <span
                  v-if="data.item.source == 'EM'">Emerchant</span>
                <span
                  v-else-if="data.item.source == 'TL'">{{ $t("salon_report.stock.manual") }}</span>
              </template>
              <template #cell(blocked)="data">
                <span
                  class="badge badge-success fw-400"
                  v-if="data.item.blocked != 0">{{ $t("button_link.yes") }}</span>
                <span class="badge badge-danger fw-400" v-else>{{
                  $t("button_link.no")
                }}</span>
              </template>
              <template #cell(action)="data">
                <b-button
                  @click="onDataEdit(data.item)"
                  tabindex="0"
                  variant="outline-primary">
                  <i class="fal fa-pencil fs-xl"></i>
                </b-button>
                <!-- <b-button
                                 v-b-modal.appointmentModal
                  :disabled="editBlock"
                  @click="appointmentDetail = data.item"
                  tabindex="0"
                  variant="outline-primary"
                >
                  <i class="fal fa-pencil fs-xl"></i>
                </b-button> -->
              </template>
              <template #row-details="row">
                <b-card>
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold">Name</label>
                        <span>
                          {{ row.item.memberName }}
                        </span>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Staff Name </label>
                        <span>
                          {{ row.item.staffName }}
                        </span>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Mobile </label>
                        <span>
                          {{ row.item.memberMobile }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <div class="d-flex">
                          <label class="font-weight-bold">Appointment Date</label>
                          <!-- <a class="link text-primary ml-1">
                            <b-icon variant="primary" icon="pencil"></b-icon>
                          </a> -->
                        </div>
                        <span>
                          {{
                            formatDate(
                              row.item.arrivalDate,
                              "DD MMM YYYY hh:mm A",
                              row.item.timezone
                            )
                          }}
                          ({{ row.item.duration }} Minutes)
                        </span>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Create Date </label>
                        <span>
                          {{
                            formatDate(
                              row.item.createDate,
                              "DD MMM YYYY hh:mm:ss A",
                              row.item.timezone
                            )
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Reminder Date </label>
                        <span>
                          {{
                            formatDate(
                              row.item.reminderDate,
                              "DD MMM YYYY",
                              row.item.timezone
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Source </label>
                        <div>
                          <span
                            class="badge badge-success fw-400"
                            v-if="row.item.source == 'OL'">{{ $t("label.online") }}</span>
                          <span
                            class="badge badge-success fw-400"
                            v-else-if="row.item.source == 'EM'">Emerchant</span>
                          <span
                            class="badge badge-primary fw-400"
                            v-else-if="row.item.source == 'TL'">{{ $t("salon_report.stock.manual") }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Status </label>
                        <div>
                          <span
                            class="badge badge-success fw-400"
                            v-if="row.item.completedDate != 0">Completed</span>
                          <span
                            class="badge badge-warning fw-400"
                            v-else-if="row.item.noshowDate !== 0">No Show</span>
                          <span class="badge badge-primary fw-400" v-else>Approved</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <div class="d-flex">
                          <label class="font-weight-bold"> Color </label>
                          <!-- <a class="link text-primary ml-1">
                            <b-icon variant="primary" icon="pencil"></b-icon>
                          </a> -->
                        </div>
                        <span>
                          {{ row.item.color }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-4">
                    <div class="col-sm-6">
                      <div class="d-flex flex-column">
                        <div class="d-flex">
                          <label class="font-weight-bold"> Remarks </label>
                          <a class="link text-primary ml-1" v-b-modal.editRemarkModal @click.stop="editRemark(row.item)">
                            <b-icon variant="primary" icon="pencil"></b-icon>
                          </a>
                        </div>
                        <div>
                          {{ row.item.remark !== "" ? row.item.remark : "-" }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <template v-if="row.item.noshowDate === 0 && row.item.completedDate === 0" #footer>
                    <div class="d-flex justify-content-between w-100">
                      <b-button
                        class="mr-2"
                        pill
                        size="xs"
                        variant="outline-danger"
                        @click="onApptActionClick(row.item.bookID, 'delete')"><b-icon icon="trash"></b-icon></b-button>
                      <div>
                        <template v-if="showCompleteOrNoShowButton(row.item.arrivalDate)">
                          <b-button
                            class="mr-2"
                            pill
                            variant="warning"
                            @click="onApptActionClick(row.item.bookID, 'noshow')">No Show <i class="fa fa-times-circle fs-xl"></i></b-button>
                          <b-button
                            class="mr-2"
                            pill
                            variant="success"
                            @click="onApptActionClick(row.item.bookID, 'completed')">Completed <i class="fa fa-check-circle fs-xl"></i></b-button>
                        </template>
                        <b-button
                          class="mr-2"
                          pill
                          variant="danger"
                          v-if="row.item.blocked == 0"
                          @click="onApptActionClick(row.item.bookID, 'blocked')">Block <i class="fa fa-exclamation-triangle fs-xl"></i></b-button>
                      </div>
                    </div>
                  </template>
                </b-card>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
        {{ $t("table.no_records") }}
      </div>
    </div>
    <b-modal id="editRemarkModal" size="md" title="Edit Remarks">
      <textarea name="" id="" cols="30" rows="6" v-model="appointmentEditForm.remark" class="form-control"></textarea>
      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-center">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="saveEditRemark()">Save</b-button>
        </div>
      </template>
    </b-modal>
    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>

  </div>
</template>
<script>
import moment, { RFC_2822 } from "moment-timezone";
import DateRangePicker from "vue2-daterange-picker";
import SchedulerView from "./Scheduler";
import CalendarView from "./fullCalendar";
import {
  handleSessionExpired,
  setReturnData,
  getOutletList,
  getStaffList,
} from "./../../../../assets/js/dashboard/dashboard.js";
import AppointmentModal from "./Appointment_Modal";
import Swal from "sweetalert2";
export default {
  name: "appointmentFilter",
  props: {
    tab: String,
    skus: Array,
    COLOR_CONST_RAW: Array,
  },
  components: {
    DateRangePicker,
    CalendarView,
    SchedulerView,
    AppointmentModal,
  },
  data() {
    let now = moment();

    let dateRangeList = {
      startDate: now.startOf("month").toDate(),
      endDate: now.endOf("month").toDate(),
    };
    return {
      colorList: [],

      editBlock: false,
      appointmentDetail: {},
      appointmentEditForm: {
        remark: ""
      },
      outletID: "",
      staffID: 0,
      outlet: [],
      staffs: [],
      calendarType: 'dayGridMonth',
      dateRange: {},
      dateRangeList,
      dateRangeCalendar: {},
      singleDatePicker: true,
      selectedTabView: "active",
      selectedOutlet: {
        text: "",
        bizName: "",
        id: "",
      },
      searchAppt: "",
      isSpinnerShow: false,
      spinnerHour: false,
      searchFilter: "",
      searchCustomer: "",
      selectedVisit: "",
      selectedStaff: {
        staffID: '',
        name: "All Staffs",
        deleteDate: 0,
      },
      selectedStatus: "all",
      apptData: [],
      apptLists: [],
      apptHours: [],
      apptHoursClone: [],
      skuList: [],
      hoursOutlet: {
        text: "Select Outlet",
        bizName: "Select Outlet",
        id: "",
      },
      predefinedHours: "",
      apptSource: "",
      source: "",

      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,

      exportHeaders: [],
      exportData: [],
      exportFileName: "",

      calendarDateEdited: null,
    };
  },
  computed: {
    hourOutlet() {
      let array = [
        {
          text: "Select Outlet",
          bizName: "Select Outlet",
          id: "",
        },
      ];
      array = array.concat(JSON.parse(this.$store.state.outlets));
      return array;
    },
    radStatus() {
      return this.$i18n.messages[this.$i18n.locale].appointment
        .option_status_filter;
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "datetime",
          label: 'Date & Time',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
          sortable: true,
        },
        {
          key: "customer",
          label: 'Customer',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
          sortable: true,
        },
        {
          key: "service",
          label: "Service",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "colorAndRemark",
          label: "Color & Remark",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "status",
          label: "Status",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "source",
          label: "Source",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle text-center",
        },
        {
          key: "action",
          label: " Action",
          thClass: "thead-themed align-middle",
          tdClass: " align-middle text-center",
        },
      ];
    },
    exportFields() {
      var ret = {};
      ret["#"] = "index";
      ret["NAME"] = "name";
      ret["MOBILE"] = "mobile";
      ret["CREATE_DATE"] = "createDate";
      ret["ARRIVAL_DATE"] = "arrivalDate";
      ret["STAFF_NAME"] = "staff";
      ret["SKU"] = "sku";
      ret["OUTLET"] = "outlet";
      ret["REMARK"] = "remarks";

      return ret;
    },
  },
  watch: {
    // searchCustomer(val) {
    //   this.apptLists = this.apptData.filter((item) => {
    //     let member = item.member.toUpperCase();
    //     let search = val.toUpperCase();
    //     if (item.mobile.includes(val) || member.includes(search)) {
    //       return item;
    //     }
    //   });
    //   this.totalEntries = this.apptLists.length;
    // },
    apptSource(val) {
      this.setAppointmentList();
    },
    predefinedHours(val) {
      switch (val) {
        case "1":
          for (let x = 0; x < 24; x++) {
            if (x > 8 && x < 18) {
              this.apptHours[x].appt = true;
            } else {
              this.apptHours[x].appt = false;
            }
          }
          break;
        case "2":
          for (let x = 0; x < 24; x++) {
            if (x > 9 && x < 19) {
              this.apptHours[x].appt = true;
            } else {
              this.apptHours[x].appt = false;
            }
          }
          break;
        case "3":
          for (let x = 0; x < 24; x++) {
            this.apptHours[x].appt = true;
          }
      }
    },
    tab(val) {
      if(this.tab === 'list') {
        if(!this.calendarDateEdited) {
          let now = moment()
          this.dateRangeList = {
            startDate: now.startOf("month").toDate(),
            endDate: now.endOf("month").toDate(),
          };
        }

        this.singleDatePicker = false
      } else {
        this.singleDatePicker = true
      }

      this.updateDateRange()
      this.setAppointmentList()
    },
  },
  methods: {
    getDate(date) {
      let temp = moment(date)
      return temp.format('ddd, DD/MM/YYYY')
    },
    getTime(date, duration) {
      let temp = moment(date)
      if (duration) {
        temp.add(duration, 'minutes')
      }
      return temp.format('hh:mm A')
    },
    getDateTime(date, duration) {
      let temp = moment(date)
      if (duration) {
        temp.add(duration, 'minutes')
      }
      return temp.format('hh:mm A')
    },
    formatDate(date, format, tz) {
      let now = moment(date).format(format);
      return now;
    },

    filterByOutlet(val) {
      this.currentPage = 1
      this.outletID = val.id;
      this.selectedOutlet = val;
      this.selectedStaff = {
        staffID: '',
        name: "All Staffs",
      };
      this.staffID = "";
      this.setAppointmentList();
      this.getApptHours({ id: val.id })
    },
    filterBySearch() {
      this.page = 0
      this.setAppointmentList();
    },
    filterByStaff(val) {
      this.page = 0
      this.staffID = val.staffID;
      this.setAppointmentList();
    },
    filterByDate() {
      this.page = 0

      if (this.tab === 'calendar') {
        this.$refs['calendar'].setDate(this.dateRangeList.startDate, this.dateRangeList.endDate)
      } else {
        this.setAppointmentList();
      }
    },
    clearFilter() {
      this.page = 0
      this.selectedOutlet = {
        text: "All Outlets",
        bizName: "All Outlets",
        id: "",
      };
      this.selectedStaff = {
        staffID: '',
        name: "All Staffs",
      };
      this.staffID = ''
      this.selectedStatus = "all";
      this.searchCustomer = "";
      this.apptSource = "";

      this.setAppointmentList();
    },

    onCalendarDateClick(date, staffID) {
      this.$emit("openAddModal", date, staffID, this.selectedOutlet.id);
    },
    onCalendarDateChange(filter) {
      if(this.calendarDateEdited === null) {
        this.calendarDateEdited = false
      } else {
        this.calendarDateEdited = true
      }

      let start = this.dateRangeCalendar.startDate = filter.start
      let end = this.dateRangeCalendar.endDate = filter.end

      this.calendarType = filter.view.type
      if (this.calendarType === 'dayGridMonth') {
        if (start.getDate() > 20) {
          start = moment(start).add(1, 'month').startOf('month').toDate()
        }
        if (end.getDate() < 20) {
          end = moment(end).subtract(1, 'month').endOf('month').toDate()
        }
      } else if (this.calendarType === 'dayGridWeek') {
        start = moment(start).startOf('week').add(1, 'day').toDate()
        end = moment(start).endOf('week').add(1, 'day').toDate()
      } else if (this.calendarType === 'resourceTimeGridDay') {
        start = moment(start).startOf('day').toDate()
        end = moment(start).endOf('day').toDate()
      }

      this.updateDateRange()

      this.dateRangeList.startDate = start
      this.dateRangeList.endDate = end
      this.setAppointmentList()
    },
    updateDateRange() {
      if(this.tab === 'list') {
        this.dateRange =  {
          "Today": [
            moment().toDate(), 
            moment().toDate()
          ],
          "Yesterday": [
            moment().subtract(1, "days").toDate(),
            moment().subtract(1, "days").toDate(),
          ],
          "Tomorrow": [
            moment().add(1, "days").toDate(),
            moment().add(1, "days").toDate(),
          ],
          "Last 7 Days": [
            moment().subtract(6, "days").toDate(),
            moment().toDate(),
          ],
          "Last 30 Days": [
            moment().subtract(29, "days").toDate(),
            moment().toDate(),
          ],
          "This Week": [
            moment().startOf("week").toDate(), 
            moment().endOf("week").toDate()
          ],
          "This Month": [
            moment().startOf("month").toDate(),
            moment().endOf("month").toDate(),
          ],
          "This Year": [
            moment().startOf("year").toDate(), 
            moment().endOf("year").toDate()
          ],
          "Last Week": [
            moment().subtract(1, "week").startOf("week").toDate(),
            moment().subtract(1, "week").endOf("week").toDate(),
          ],
          "Last Month": [
            moment().subtract(1, "month").startOf("month").toDate(),
            moment().subtract(1, "month").endOf("month").toDate(),
          ],
          "Last Year": [
            moment().subtract(1, "year").startOf("year").toDate(),
            moment().subtract(1, "year").endOf("year").toDate(),
          ],
          "Next Week": [
            moment().add(1, "week").startOf("week").toDate(),
            moment().add(1, "week").endOf("week").toDate(),
          ],
          "Next Month": [
            moment().add(1, "month").startOf("month").toDate(),
            moment().add(1, "month").endOf("month").toDate(),
          ],
          "Next Year": [
            moment().add(1, "year").startOf("year").toDate(),
            moment().add(1, "year").endOf("year").toDate(),
          ],
        };

        return
      }

      if (this.calendarType === 'dayGridMonth') {
        this.dateRange =  {
          "This Month": [
            moment().startOf("month").toDate(),
            moment().endOf("month").toDate(),
          ],
          "Last Month": [
            moment().subtract(1, "month").startOf("month").toDate(),
            moment().subtract(1, "month").endOf("month").toDate(),
          ],
          "Next Month": [
            moment().add(1, "month").startOf("month").toDate(),
            moment().add(1, "month").endOf("month").toDate(),
          ],
        };
      } else if(this.calendarType === 'dayGridWeek') {
        this.dateRange =  {
          "This Week": [
            moment().startOf("week").add(1, 'day').toDate(),
            moment().endOf("week").add(1, 'day').toDate(),
          ],
          "Last Week": [
            moment().subtract(1, "week").startOf("week").add(1, 'day').toDate(),
            moment().subtract(1, "week").endOf("week").add(1, 'day').toDate(),
          ],
          "Next Week": [
            moment().add(1, "week").startOf("week").add(1, 'day').toDate(),
            moment().add(1, "week").endOf("week").add(1, 'day').toDate(),
          ],
        };
      } else if(this.calendarType === 'resourceTimeGridDay') {
        this.dateRange =  {
          "Today": [
            moment().startOf("day").toDate(),
            moment().endOf("day").toDate(),
          ],
          "Yesterday": [
            moment().subtract(1, "day").startOf("day").toDate(),
            moment().subtract(1, "day").endOf("day").toDate(),
          ],
          "Tomorrow": [
            moment().add(1, "day").startOf("day").toDate(),
            moment().add(1, "day").endOf("day").toDate(),
          ],
        };
      }
    },

    getOutlet(id) {
      return this.outlet.filter((obj) => obj.id == id)[0].bizName;
    },
    async getColorList() {
      let url = "/colors";
      await this.$axios({
        method: "get",
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$session.get("token") },
      })
        .then((response) => {
          this.colorList = response.data.colors.map(k => {
            let temp = this.COLOR_CONST_RAW[k['colorID']]
            if(temp) {
              k['hex'] = temp
            }
            return k
          });
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },
    async setAppointmentList() {
      this.isSpinnerShow = true;
      let $vm = this;

      if(!this.colorList || this.colorList.length === 0) {
        await this.getColorList()
      }

      // let start = moment(this.dateRangeList.startDate).startOf('day')
      // let end = moment(this.dateRangeList.endDate).endOf('day')
      // let QUERY_STRING = "?start=" + start.unix() + "&stop=" + end.unix()

      // await $vm
      //   .$axios({
      //     method: "get",
      //     url: `https://appt.tunai.io/business/summary${QUERY_STRING}`,
      //     headers: { token: $vm.$session.get("token") },
      //   })
      //   .then((response) => {
      //     console.log(response.data)
      //   })
      //   .catch((err) => {
      //     var errData = err.response.data;
      //     if (errData.error == $vm.$api.INVALID_TOKEN) {
      //       handleSessionExpired();
      //     }
      //   });

      var temp = await this.getAppointmentList();
      this.$emit("selectedOutlet", this.selectedOutlet);

      let staffApptCount = {}

      this.staffs = [{ staffID: "", name: "All Staffs", total: "all", deleteDate: 0 }];
      this.staffs = this.staffs.concat(JSON.parse(this.$store.state.staffs));
      this.staffs = this.staffs.filter((s) => {
        if (s.staffID === '') {
          return s
        }

        if (s.outletID == this.outletID) {
          s.total = staffApptCount[s.staffID] || 0
          return s;
        }
      });
      this.staffs.sort((a, b) => {
        return b.total - a.total;
      });

      this.apptData = JSON.parse(JSON.stringify(temp));
      this.apptLists = temp
      if (this.tab === 'calendar') {
        this.$refs['calendar'].setAppointmentList(temp)
      }

      this.isSpinnerShow = false;
    },
    async getAppointmentList(report) {
      let $vm = this;
      let QUERY_STRING = "";
      
      let start = moment(this.dateRangeList.startDate).startOf('day')
      let end = moment(this.dateRangeList.endDate).endOf('day')
      QUERY_STRING = "?start=" + start.unix() + "&stop=" + end.unix()

      if (this.outletID) {
        QUERY_STRING += "&outletID=" + this.outletID;
      }

      if (this.staffID) {
        QUERY_STRING += "&staffID=" + this.staffID;
      }

      if (this.selectedStatus) {
        QUERY_STRING += "&status=" + this.selectedStatus;
      }

      if (this.apptSource) {
        QUERY_STRING += "&source=" + this.apptSource;
      }

      if (this.searchCustomer) {
        QUERY_STRING += "&search=" + this.searchCustomer;
      }

      if (!report && this.tab === 'list') {
        QUERY_STRING += "&page=" + this.page;
      }

      var result = {};
      await $vm
        .$axios({
          method: "get",
          url: `https://appt.tunai.io/business/book${QUERY_STRING}`,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          result = response.data.books;

          result.forEach((book) => {
            book.arrivalDate = moment.unix(book.arrivalDate)
            book.createDate = moment.unix(book.createDate)
            book.reminderDate = moment.unix(book.reminderDate)

            // book.sku = sku.find((item) => item.skuID === book['sku'].skuID).name;
            book.skuName = book['sku']['name']

            // var member = members.find((item) => item.memberID === book['member'].memberID)
            // book.member = member.name == "" ? member.mobile : member.name;
            // book.mobile = member.mobile;
            book.memberID = book['member']['memberID']
            book.memberName = book['member']['name']
            book.memberMobile = book['member']['mobile']

            // book.staff = staffs.find((item) => item.staffID === book.staffID);
            // book.staff = book.staff != undefined ? book.staff.name : "-";
            book.staffID = book['staff']['staffID']
            book.staffName = book['staff']['name']

            book.colorID = book['color']['colorID']
            book.colorObj = this.colorList.find((item) => item.colorID === book.colorID)
            if (book.colorObj) {
              book.color = book.colorObj.color
              book.colorHex = book.colorObj.hex
            }
            
            book.remark = book['remarks']['remarks']
            book.remarkEditView = false;
          });

          if(!report) {
            var retData = setReturnData(response.data.books, response.data.total, $vm.page)
            $vm.totalEntries = retData.count;
            $vm.totalPage = retData.totalPage;
            $vm.startPage = retData.startPage;
            $vm.endPage = retData.endPage;
          }

          if(response.data.books.length === response.data.total || report) {
            $vm.setExportData(result)
            return
          }

          if(response.data.books.length !== response.data.total || !report) {
            this.getAppointmentList(true)
          }
        })
        .catch((err) => {
          console.log(err)
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
    handlePagination(pg) {
      if (pg != null) {
          this.page = pg - 1
          this.setAppointmentList()
      }
    },
    setExportData(data) {
      this.exportData = [];
      let header = this.$msg.REPORT.HEADER + this.$i18n.t("subMenu.my_salon_appointment");
      this.exportHeaders = [
        header,
        this.$i18n.t("table.report_generate") +
        moment().format(this.$msg.CST.DATE_TIME_24),
        " ",
      ];

      this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV;

      for (var i = 0; i < data.length; i++) {
        this.exportData.push({
          index: i + 1,
          createDate: this.formatDate(data[i].createDate, "DD MMM YYYY hh:mm:ss A", data[i].timezone),
          arrivalDate: this.formatDate(data[i].arrivalDate, "DD MMM YYYY hh:mm A", data[i].timezone),
          outlet:
            data[i].outletID == 0
              ? this.$i18n.t("label.all", {
                item: this.$i18n.t("label.outlet"),
              })
              : this.getOutlet(data[i].outletID),
          name: data[i].memberName,
          mobile: data[i].memberMobile,
          staff: data[i].staffName,
          sku: data[i].skuName,
          color: data[i].colorName,
          remarks: data[i].remarks.remarks,
        });
      }
    },

    onDataEdit(data) {
      this.appointmentDetail = this.apptData.filter((item) => {
        if (item.bookID == data.bookID) return item;
      })[0];
      this.$emit("openEditModal", data);
    },
    onCalendarEventClick(data) {
      this.appointmentDetail = this.apptData.filter((item) => {
        if (item.bookID == data.bookID) return item;
      })[0];
      // this.$bvModal.show("appointmentModal");
      this.$emit("openEditModal", data);
    },

    addAppointment() {
      this.$emit("openAddModal", null, null, this.selectedOutlet.id);
    },

    async saveEditRemark() {
      let $vm = this;
      var result = {};
      let url = this.$api.BOOKING + "/" + this.appointmentEditForm.id + "/" + "remarks";
      let body = {
        remarks: $vm.appointmentEditForm.remark
      };
      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: "https://appt.tunai.io/",
          data: body,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          result = response;
        })
        .catch((err) => {
          this.toastrExe(
            "Appointment Update",
            `Update for Book ID:${$vm.appointmentEditForm.id} Failed`,
            "danger"
          );
          result = err.response;
          var errData = err.response?.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status === 200)
        this.toastrExe(
          "Appointment Update",
          `Book ID:${$vm.appointmentEditForm.id} remarks edited`,
          'success'
        );
      this.setAppointmentList();
      this.$bvModal.hide("editRemarkModal");
    },
    editRemark(row) {
      this.appointmentEditForm.id = row.bookID;
      this.appointmentEditForm.remark = row.remarks;
    },

    showCompleteOrNoShowButton(date) {
      let arrival = new Date(date).getTime();
      let now = new Date().getTime();
      if (arrival <= now) {
        return true;
      } else {
        return false;
      }
    },
    async onApptActionClick(bookID, operation) {
      let flag = false;
      let text = "";
      if (operation === 'noshow')
        text = "'no show'"
      else if (operation === 'completed')
        text = "complete"
      else if (operation === 'delete')
        text = "delete"
      else if (operation === 'blocked')
        text = "block"

      await Swal.fire({
        title: `Confirm ${text} appointment?`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let $vm = this;
      var result = {};
      let url = this.$api.BOOKING + "/" + bookID + "/" + operation;
      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: "https://appt.tunai.io/",
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          this.toastrExe(
            "Appointment Update",
            operation == "delete"
              ? `Book ID:${bookID} has been deleted`
              : `Update for Book ID:${bookID} Successful`,
            "success"
          );
          result = response;
        })
        .catch((err) => {
          this.toastrExe(
            "Appointment Update",
            `Update for Book ID:${bookID} Failed`,
            "danger"
          );
          result = err.response;
          var errData = err.response?.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status === 200)
        this.setAppointmentList();
    },

    onApptHourToggle(index) {
      this.apptHours[index].appt = !this.apptHours[index].appt;
    },
    async getApptHours(event) {
      this.spinnerHour = true;
      let url = `https://bebusiness.tunai.io/outlet/${event.id}/bookhour`;

      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.hours;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
        
      this.apptHours = result;
      this.apptHours.forEach((appt) => {
        appt.appt = appt.appt == 1 ? true : false;
      });
      this.apptHoursClone = JSON.parse(JSON.stringify(this.apptHours));
      this.spinnerHour = false;
    },
    async updateApptHours() {
      let hours = [];
      let body = {};
      let url = "";
      let flag = false;
      let result = null;
      let appt = this.apptHours;
      let apptClone = this.apptHoursClone;
      for (var x = 0; x < appt.length; x++) {
        appt[x].appt = appt[x].appt ? 1 : 0;
        hours.push(appt[x]);
      }
      if (hours.length == 1) {
        url = `https://bebusiness.tunai.io/outlet/${this.hoursOutlet.id}/bookhour/${hours[0].hourID}/appt`;
        body = {
          appt: hours[0].appt.toString(),
        };
      } else if (hours.length > 1) {
        let ids = [];
        hours.filter((item) => {
          if (item.appt == 1 || item.appt) {
            ids.push(item.hourID);
          }
        });
        url = `https://bebusiness.tunai.io/outlet/${this.hoursOutlet.id}/bookhour/batch`;
        body = {
          batch: ids,
        };
      } else {
        this.toastrExe(
          "Appointment Hours Update",
          "No changes applied",
          "warning"
        );
        return;
      }
      await this.$axios({
        method: "post",
        url: url,
        data: body,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          flag = true;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (flag) {
        this.toastrExe(
          "Appointment Hours Update",
          "Error during submission",
          "danger"
        );
      } else {
        this.toastrExe(
          "Appointment Hours Update",
          "Successfully updated appointment hours",
          "success"
        );
      }
      this.getApptHours(this.hoursOutlet);
    },

    toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
  },
  mounted() {
    // this.setAppointmentList();
    let blocks = this.$store.state.blockList;
    blocks.forEach((element) => {
      if (element == "biz.appt.edit") this.editBlock = true;
    });

    this.getColorList()

    this.dateRange =  {
      "This Month": [
        moment().startOf("month").toDate(),
        moment().endOf("month").toDate(),
      ],
      "Last Month": [
        moment().subtract(1, "month").startOf("month").toDate(),
        moment().subtract(1, "month").endOf("month").toDate(),
      ],
      "Next Month": [
        moment().add(1, "month").startOf("month").toDate(),
        moment().add(1, "month").endOf("month").toDate(),
      ],
    };

    this.outlet = [];
    this.outlet = this.outlet.concat(JSON.parse(this.$store.state.outlets));
    this.selectedOutlet = this.outlet[0];
    this.outletID = this.outlet[0].id;
    this.getApptHours({ id: this.outletID })
  },
};
</script>
<style>
@media only screen and (max-width: 2300px) {
  .hourButtons {
    flex: 0 0 10%;
    max-width: 8%;
    padding: 5px;
  }

  .apptTable {
    font-size: 1em;
  }
}

@media only screen and (max-width: 1600px) {
  .hourButtons {
    flex: 0 0 25%;
    max-width: 25%;
    padding: 5px;
  }

  .apptTable {
    font-size: 0.9em;
  }
}

@media only screen and (max-width: 1300px) {
  .hourButtons {
    flex: 0 0 30%;
    max-width: 30%;
    padding: 5px;
  }

  .apptTable {
    font-size: 0.7em;
  }
}

@media only screen and (max-width: 800px) {
  .hourButtons {
    flex: 0 0 40%;
    max-width: 40%;
    padding: 5px;
  }

  .apptTable {
    font-size: 0.4em;
  }
}
</style>